import React from 'react';

import { Box} from '@mui/material';
import { Container } from '@mui/material';

import UpdateBankBranchForm from '../Components/UpdateBankBranchForm';

export default function UpdateBankBranchPage() {
  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Container>
        <UpdateBankBranchForm/>
      </Container>
    </Box>
  )
}
